import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UserApiService } from '../user/user.service';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private userService: UserApiService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAuth(route);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAuth(childRoute);
  }

  private checkAuth(route: ActivatedRouteSnapshot): boolean | UrlTree {
    // Si la sesión expiró (401), se debe permitir mostrar la pantalla de login con el mensaje correspondiente
    if (route.queryParamMap.get('sessionExpired') === 'true') {
      return true;
    }

    if (this.userService.isAuthenticated()) {
      const targetUrl = this.userService.getDefaultRedirectUrl();
      if (targetUrl.startsWith('/migration')) {
        window.location.assign(targetUrl);
        return false;
      }
      return this.router.parseUrl(targetUrl);
    }

    return true;
  }
}
